import {
  Stack,
  Box,
  Typography,
  IconButton,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React from 'react';



export type AttachmentCardProps = {
  id: string;
  fileName: string;
  url: string;
  formattedFileSize: string;
  handleDelete: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: AttachmentCardProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction='row'
      borderRadius='1rem'
      bgcolor={theme.palette.secondary.main}
      padding='1rem'
      justifyContent='space-between'
      rowGap='.5rem'
    >
      <Box>

        <Box>
          <Typography
            variant='bodyBold'
          >
            {props.fileName}
          </Typography>
        </Box>
        <Box>
          <Typography>
            Size: {props.formattedFileSize}
          </Typography>
        </Box>
      </Box>
      <Box>
        {props.url !== ''
        && (
          <IconButton
            onClick={() => {
              handleDownload(props.url);
            }}
            sx={{
              cursor: 'pointer'
            }}
          >
            <CustomIcon.large.FC
              icon='DOWLOAD'
              stroke={theme.palette.primary.main}
            />
          </IconButton>
        )}
        <IconButton
          onClick={() => {
            props.handleDelete();
          }}
          sx={{
            cursor: 'pointer'
          }}
        >
          <CustomIcon.large.FC
            icon='DELETE'
            stroke={theme.palette.error.main}
          />
        </IconButton>
      </Box>
    </Stack>
  );
};

const handleDownload = (url: string) => {
  window.open(url, '_blank');
};
